import { useState } from "react";

import { UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import { Button, Modal, Typography, Upload, message } from "antd";
import { useDispatch } from "react-redux";
import {
  GetQrCodesList,
  UploadExcelSheet,
} from "../../../redux/actions/qrCodes/qrCodes-action";
import Alertify from "../../../services/alertify";

const { Title } = Typography;
const ExcelUpload = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [errorsModal, setErrorsModal] = useState(false);
  const [errors, setErrors] = useState([]);

  const handleUpload = () => {
    if (fileList.length === 0) {
      message.error("Please select a file first!");
      return;
    }

    const file = fileList[0];
    setLoading(true);
    dispatch(UploadExcelSheet({ file }))
      .then((response) => {
        setLoading(false);
        if (response.error) {
          message.error(`${file.name} upload failed.`);
        } else {
          message.success(`${file.name} uploaded successfully.`);
          console.log("Response is:", response);
          if (response?.payload?.data?.errors.length > 0) {
            setErrors(response?.payload?.data?.errors);
            setErrorsModal(true);
          }
          setFileList([]);
          props.setQrModal(false);
          dispatch(
            GetQrCodesList({
              page: 1,
              limit: 10,
              region: props.region,
              search: "",
            })
          )
            .then((response) => {
              const data = response?.payload?.data?.data || [];
              const dataWithKeys = data.map((item, index) => ({
                ...item,
                key: item.qrId || `warranty-${index}`,
              }));
              props.setPagination((prevPagination) => ({
                ...prevPagination,
                total: response?.payload?.data?.total,
              }));
              props.setDataSource(dataWithKeys);
            })
            .catch((error) => {
              Alertify.error("Error fetching QR Code list. Please try again.");
            });
        }
      })
      .catch((error) => {
        setLoading(false);
        message.error(`${file.name} upload failed.`);
      });
  };

  const downloadSample = () => {
    const sampleFileUrl = "/assets/sample_qr_upload.xlsx";
    const link = document.createElement("a");
    link.href = sampleFileUrl;
    link.download = "sample_qr_upload.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const uploadProps = {
    name: "file",
    accept: ".xlsx",
    fileList,
    beforeUpload: (file) => {
      const isExcel =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isExcel) {
        message.error("You can only upload .xlsx files!");
        return Upload.LIST_IGNORE;
      }

      setFileList([file]);
      return false; // Prevent auto upload
    },
    onRemove: () => {
      setFileList([]);
    },
  };
  console.log("Errors:", errors);
  return (
    <>
      <Title level={4} className="text-center mt-4">
        OR
      </Title>
      <Title level={5} className="mt-4 text-center">
        Upload Excel(.xlsx) Sheet for Bulk QR Code Generation
      </Title>
      <div className="flex justify-center mt-2">
        <Button
          type="link"
          icon={<DownloadOutlined />}
          onClick={downloadSample}
        >
          Download Sample Excel
        </Button>
      </div>
      <div className="flex gap-4 mt-4 justify-center items-center">
        <Upload {...uploadProps}>
          <Button icon={<UploadOutlined />}>Select Excel File</Button>
        </Upload>

        <Button
          type="primary"
          onClick={handleUpload}
          disabled={fileList.length === 0}
          loading={loading}
        >
          Upload Excel Sheet
        </Button>
      </div>
      <Modal
        open={errorsModal}
        className="rounded-lg"
        centered
        onCancel={() => setErrorsModal(false)}
        footer={false}
      >
        <p className="text-center text-red-500 text-2xl font-semibold">
          Errors
        </p>
        <div className="flex flex-col gap-2 mt-4 max-h-[60vh] overflow-y-scroll">
          {errors.map((error, index) => (
            <div key={index} className="bg-red-100 p-2 rounded-lg border-2">
              <div>
                <strong>Row Number:</strong> {error.row}
              </div>
              <div>
                <strong>Reason:</strong> {error.reason}
              </div>
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
};

export default ExcelUpload;
